import React, { ChangeEvent, FormEvent, useState } from 'react';

import { useSnackbar } from 'notistack';

import { Backdrop, Box, Button, CircularProgress, FormGroup, Stack, TextField } from '@mui/material';

import { uploadCommissionPayment } from '~/services/AgentHub/AgentService';

function UploadCommissionPayment() {
  const { enqueueSnackbar } = useSnackbar();

  const [isUploading, setIsUploading] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  function onChange(event: ChangeEvent<HTMLInputElement>) {
    setFile(event.target.files[0]);
  }

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsUploading(true);

    const formData = new FormData();
    formData.append('file', file);

    try {
      await uploadCommissionPayment(formData);
      setIsUploading(false);
      enqueueSnackbar('File upload successful', {
        variant: 'success',
      });
    } catch (error) {
      setIsUploading(false);
      enqueueSnackbar(`Error uploading file. ${error.message}`, {
        variant: 'error',
      });
    } finally {
      setFile(null);
      setIsUploading(false);
    }
  }

  return (
    <Stack spacing={2}>
      <Box>
        <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isUploading}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Box>

      <form onSubmit={onSubmit}>
        <Stack spacing={2} display="block">
          <FormGroup>
            <TextField
              label="File Upload"
              type="file"
              name="file"
              onChange={onChange}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                accept: '.csv',
              }}
              fullWidth
            />
          </FormGroup>

          <Button type="submit" variant="contained">
            Upload payments
          </Button>
        </Stack>
      </form>
    </Stack>
  );
}

export default UploadCommissionPayment;
